export default __webpack_public_path__ + "static/media/kozelkov.50b2fda1.jpg";